var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThrivingCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4998 145C56.7998 145 42.1998 140 30.2998 131.5L39.4998 123.6C48.9998 129.8 60.2998 133.3 72.4998 133.3C97.0998 133.3 118.4 118.6 127.9 97.5L138.7 102C127.5 127.4 102.1 145 72.4998 145Z",
    fill: "#00B3C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 10.2002C14.3 22.8002 0 46.0002 0 72.5002C0 91.8002 7.49999 109.3 19.8 122.3L28.7 114.6C18.2 103.7 11.7 88.8002 11.7 72.5002C11.7 49.9002 24 30.2002 42.3 19.8002L35.5 10.2002Z",
    fill: "#58CBF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145 72.5C145 78.1 144.4 83.6 143.1 88.9L132.1 84.3C132.9 80.5 133.2 76.5 133.2 72.5C133.2 38.9 106 11.7 72.3996 11.7C66.3996 11.7 60.6996 12.6 55.1996 14.2L48.0996 4.2C55.6996 1.5 63.8996 0 72.3996 0C112.6 0 145 32.5 145 72.5Z",
    fill: "#1484FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrivingCircle);
export default __webpack_public_path__ + "static/media/thrivingCircle.279495c1574d63d708954ba5d09e2690.svg";
export { ForwardRef as ReactComponent };